import { createStore } from "vuex";
import Vue from "vue";

export default createStore({
  state: {
    pageTransition: {
      name: "router-view",
      mode: "in-out",
    },
  },
  mutations: {
    setPageTransition(state, value) {
      if ("default" === value) {
        Vue.set(state, "pageTransition", {
          name: "router-view",
          mode: "in-out",
        });
      }
      if ("back" === value) {
        Vue.set(state, "pageTransition", {
          name: "router-view-back",
          mode: "in-out",
        });
      }
    },
  },
  actions: {},
  modules: {},
});
